module.exports = __webpack_public_path__ + "static/great-service-eaf0ae5e116b748b16b93488f2f894ae.png";